import React from 'react';
import PropTypes from 'prop-types';
import { ConnectedDeleteSegment } from './DeleteSegment';
import { Span } from '../../../../layouts';

export const DeleteSegmentDesktop = ({ index }) => (
    <ConnectedDeleteSegment
        index={index}
        render={
            ({ onClick, shouldShow }) => (
                <Span
                    className="odf-icon odf-icon-cross-light odf-icon-2xl odf-text-mono-color-04
                    odf-clickable odf-space-inner-left-s odf-space-outer-top-m"
                    onClick={onClick}
                    visibility={shouldShow ? 'visible' : 'hidden'}
                />
            )
        }
    />
);

DeleteSegmentDesktop.propTypes = {
    index: PropTypes.number.isRequired,
};
